import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Row, Col, Card, Button, message } from "antd";
import { deleteApplication, getApplication } from "store/auth/profile/profileSlice";
import { DeleteOutlined } from "@ant-design/icons";
const Application = () => {
  const dispatch = useDispatch()
  const applications = useSelector((state) => state.Profile.application)
  const profile = useSelector((state) => state.Profile.profile)

  useEffect(() => {
    dispatch(getApplication())
  }, [dispatch])

  const handleDelete = async (id) => {
    try {
      await dispatch(deleteApplication(id));
      message.success('deleted successfully')
      dispatch(getApplication());
      console.log('uppp')

    } catch (error) {
      console.error("Error deleting application:", error);
    }
  };

  return (
    <div className="py-4">
      <div className="
            container
            bg-light
            rounded-3
            shadow-sm
            p-3 p-sm-4 p-md-5
            mx-auto
          "
      >

        <div style={{
          // backgroundColor: '#F4F4F4',
          fontSize: '20px',
          fontWeight: '400',
          padding: '20px',
          // borderRadius: '10px',
          // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}>
          {applications && applications?.applications?.length > 0 ? (
            applications?.applications?.map((application, key) => (
              <Card key={key} style={{ marginBottom: '30px' }}>
                <Row gutter={[16, 16]}>
                  <Col span={20} className="d-flex align-items-center gap-3">
                    {/* <h3> {application.clubName}</h3>
                  <h6> {application.dateRange.startDate.slice(0,4)}-{application.dateRange.endDate.slice(0,4)}</h6>
                  <h5> {application.category}</h5> */}
                  </Col>

                  <Col
                    style={{ backgroundColor: "#F3F8F9" }}

                    className='fs-5' span={5}>
                    Club
                  </Col>
                  <Col
                    style={{ backgroundColor: "#F3F8F9" }}
                    className='fs-5' span={5}>
                    Post
                  </Col>
                  <Col
                    style={{ backgroundColor: "#F3F8F9" }}
                    className='fs-5' span={5}>
                    Date
                  </Col>
                  <Col
                    style={{ backgroundColor: "#F3F8F9" }}
                    className='fs-5 text-center' span={5}>
                    status
                  </Col>
                  <Col className='fs-5' span={5}>
                    {application?.clubName}
                  </Col>
                  <Col className='fs-5' span={5}>
                    {application?.playerPosition}
                  </Col>
                  <Col className='fs-5' span={5}>
                    {application?.createdAt.slice(0, 10)}
                  </Col>
                  <Col
                    style={{ backgroundColor: "#FFF8F0" }}
                    className='fs-5 text-center' span={5}>
                    {application?.status}
                  </Col>

                </Row>
                <Row justify="end" style={{ marginTop: '20px' }}>
                  <Col>
                    <Button
                      type="primary"
                      danger
                      onClick={() => handleDelete(application?.id)}
                      icon={<DeleteOutlined />}
                    >
                    </Button>
                  </Col>
                </Row>
              </Card>
            ))
          ) : (
            <div className="text-center py-5">
              <p>Aucune applicatin trouvée.</p>
            </div>
          )
          }

        </div>
      </div>

    </div>

  );
}

export default Application
